/* global document */
import React, {useState, useRef} from 'react';
import PropTypes from 'prop-types';

import {FilterChip, Chip, Icon, WithHoverAndFocus} from '@albert-io/atomic';

import SchoolV5Schema from 'resources/augmented/School/schemas/school_v5.schema.json';

import ZipcodeInput from './ZipcodeInput.react';

const SchoolChipFilters = ({
  countrySearchValue,
  setCountrySearchValue,
  stateSearchValue,
  setStateSearchValue,
  postalcodeSearchValue,
  setPostalcodeSearchValue
}) => {
  const USA = 'United States of America';
  const [showZipcodePopover, setShowZipcodePopover] = useState(false);
  const popoverRef = useRef();

  // Move USA to top of list with shortened value and filter out the created object from schools schema
  const countryOptions = [
    {label: 'Any country', value: undefined},
    {label: 'USA', value: USA},
    ...SchoolV5Schema.properties.data.properties.attributes.properties.country.enum.map((item) => ({
      label: item,
      value: item
    }))
  ].filter((item) => item.label !== USA);

  const stateOptions = [
    {label: 'Any state', value: undefined},
    ...SchoolV5Schema.properties.data.properties.attributes.properties.state.enum.map((item) => ({
      label: item,
      value: item
    }))
  ];

  return (
    <div className='school-lookup-modal__chip-container mt-x1 flex p-x1'>
      <FilterChip
        className='mr-x1 flex flex-nowrap items-center'
        color='brand'
        label='Country'
        menuPortalTarget={document.body}
        onChange={(option) => {
          if (setStateSearchValue) setStateSearchValue(undefined);
          if (setPostalcodeSearchValue) setPostalcodeSearchValue(undefined);
          if (option.value === 'Any') {
            setCountrySearchValue(undefined);
          } else {
            setCountrySearchValue(option);
          }
        }}
        selected={countrySearchValue || 'Any'}
        value={countrySearchValue || 'Any'}
        options={countryOptions}
      />
      {countrySearchValue.value === USA && !!setStateSearchValue ? (
        <FilterChip
          className='mr-x1 flex flex-nowrap items-center'
          label='State'
          color='brand'
          menuPortalTarget={document.body}
          onChange={(option) => {
            if (option.value === 'Any') {
              setStateSearchValue(undefined);
            } else {
              setStateSearchValue(option);
            }
          }}
          // selected={stateSearchValue || 'Any'}
          value={stateSearchValue || 'Any'}
          options={stateOptions}
        />
      ) : null}
      {countrySearchValue.value === USA ? (
        <span ref={popoverRef} className='inline-block'>
          <WithHoverAndFocus>
            {({hasFocus, hasHover, ...withHoverAndFocusHandlers}) => (
              <Chip
                as='button'
                color='brand'
                className='cursor-pointer'
                style={{height: 37}}
                onClick={() => setShowZipcodePopover(!showZipcodePopover)}
                hasFocus={hasFocus}
                hasHover={hasHover}
                {...withHoverAndFocusHandlers}
              >
                <span className='mr-x1 font-bold'>ZIP code:</span> {postalcodeSearchValue || 'Any'}
                <Icon
                  className='school-lookup-modal__chip-container__zipcode-icon'
                  icon={['fas', 'pencil-alt']}
                />
              </Chip>
            )}
          </WithHoverAndFocus>
          {showZipcodePopover && (
            <ZipcodeInput
              popoverRef={popoverRef}
              showZipcodePopover={showZipcodePopover}
              setShowZipcodePopover={setShowZipcodePopover}
              setPostalcodeSearchValue={setPostalcodeSearchValue}
              postalcodeSearchValue={postalcodeSearchValue}
            />
          )}
        </span>
      ) : null}
    </div>
  );
};

SchoolChipFilters.propTypes = {
  countrySearchValue: PropTypes.string,
  setCountrySearchValue: PropTypes.func,
  stateSearchValue: PropTypes.string,
  setStateSearchValue: PropTypes.func,
  postalcodeSearchValue: PropTypes.string,
  setPostalcodeSearchValue: PropTypes.func
};

export default SchoolChipFilters;
